import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


// STATE
const state = {
    counter: 1,
    servers: [],
    recently_connected_devices: [],
    app_debug_log: [],
}

// MUTATIONS
const mutations = {
    addDebugLine(state, payload) {
        state.app_debug_log.push(payload);
    },
    addrecentlyConnectedDevice() {

    },
    addOrUpdateServer(state, server) {

        var existingServer = state.servers.filter((elem) => elem.name === server.name && elem.type === server.type);

        if (existingServer.length < 1)
            state.servers.push(server);
        else {
            for (var i = 0; i < existingServer.length; i++) {

                var entries = Object.entries(server)

                for (const [name, value] of entries) {
                    existingServer[i][name] = value;
                }
            }
        }
    }

}

// ACTIONS
const actions = ({
    
})

export default new Vuex.Store({
  state,
  mutations,
  actions
})
